// extracted by mini-css-extract-plugin
export const navLinkAsButton = "NavLink-module--nav-link-as-button--2WJ1p";
export const navLinkDropdown = "NavLink-module--nav-link-dropdown--GZgX1";
export const dropdownBody = "NavLink-module--dropdown-body--1nXhw";
export const dropdownBodyHuge = "NavLink-module--dropdown-body-huge--25kac";